import LoginApi from "./LoginApi";
// import { mockUser } from "../user/MockUserData";

class MockLoginApi implements LoginApi {
  MOCK_PIN = "1357";

  convertAuthHashToToken = (
    authHash: string,
    reservation_id?: number,
    customer_id?: number

  ): Promise<any> => {
    // return new Promise(resolve => resolve([]));  // for testing no reservations use case
    // let mockPIN = ("000" + Math.floor(Math.random() * 10000)).substr(-4, 4);
    return new Promise(resolve =>
      setTimeout(() => resolve({ token: "M0ckT0k3n2" }), 1000)
    );
  };

  getPIN = (phoneNumber: string): Promise<any> => {
    // return new Promise(resolve => resolve([]));  // for testing no reservations use case
    // let mockPIN = ("000" + Math.floor(Math.random() * 10000)).substr(-4, 4);
    return new Promise(resolve =>
      setTimeout(() => resolve({ pin: this.MOCK_PIN }), 1000)
    );
  };

  sendAutoLink = (phoneNumber: string): Promise<any> => {
    // return new Promise(resolve => resolve([]));  // for testing no reservations use case
    // let mockPIN = ("000" + Math.floor(Math.random() * 10000)).substr(-4, 4);
    return new Promise(resolve =>
      setTimeout(() => resolve({}), 1000)
    );
  };

  tryPIN = (pin: string) => {
    // return new Promise(resolve => resolve([]));  // for testing no reservations use case
    return new Promise((resolve, reject) =>
      pin === this.MOCK_PIN
        ? setTimeout(() => resolve({ token: "M0ckT0k3n" }), 1000)
        : setTimeout(
          () =>
            reject({
              identifier: "MOCK_API_PIN_MISMATCH",
              message: "PIN Mismatch"
            }),
          1000
        )
    );
  };

  getFrontEndLink = () => {
    return new Promise((resolve, reject) => {
      const feLink =
        `${process.env.REACT_APP_FRONTEND}/#/?id=78766&hash=2d162880d6123e777edf72af533e5cc5bf26a6fe`;
      const fullLink = `${feLink}&r=2d162880d6123e777edf72af533e5cc5bf26afff`;
      setTimeout(() => resolve(fullLink), 1000);
    });
  };
}

export default MockLoginApi;
